/**
 * Gate for the `/dashboard-mock` design prototype (FE-ISSUE 15.1).
 *
 * The prototype is a fabricated, clickable Figma mock with no auth and no real
 * data — dev-only tooling. Production builds must neither route to it
 * (`beforeLoad` gate in `src/routes/dashboard-mock.tsx`) nor bundle it (the
 * route swaps the lazy import for a `() => null` stub when
 * `import.meta.env.PROD`). Same two-layer contract as `dev-sim-access.ts`.
 */
export const isDashboardMockRouteEnabled = (): boolean => !import.meta.env.PROD
